const Agreement = {
  Agreement: "Agreement.Agreement",
  Agreements: "Agreement.Agreements",
  EmploymentContract: "Agreement.EmploymentContract",
  CreateParticipantDescription: "Agreement.CreateParticipantDescription",
  Participant: "Agreement.Participant",
  ParticipantInfo: "Agreement.ParticipantInfo",
  PartyType_1: "Agreement.PartyType_1",
  PartyType_2: "Agreement.PartyType_2",
  SignMethod_2: "Agreement.SignMethod_2",
  SignMethod_3: "Agreement.SignMethod_3",
  DeliveryChannel_1: "Agreement.DeliveryChannel_1",
  DeliveryChannel_2: "Agreement.DeliveryChannel_2",
  TwoFactorAuthMethod_0: "Agreement.TwoFactorAuthMethod_0",
  TwoFactorAuthMethod_1: "Agreement.TwoFactorAuthMethod_1",
  TwoFactorAuthMethod_2: "Agreement.TwoFactorAuthMethod_2",
  Signees: "Agreement.Signees",
  SigneesDescription: "Agreement.SigneesDescription",
  AddSignee: "Agreement.AddSignee",
  SendForESign: "Agreement.SendForESign",
  SendForESignSuccessMessage: "Agreement.SendForESignSuccessMessage",
  SignAgreement: "Agreement.SignAgreement",
  SignConfirmation: "Agreement.SignConfirmation",
  SignWithOneflow: "Agreement.SignWithOneflow",
  SignWithOneflowDescription: "Agreement.SignWithOneflowDescription",
  MustSign: "Agreement.MustSign",
  Begins: "Agreement.Begins",
  Ends: "Agreement.Ends",
  EndsLast: "Agreement.EndsLast",
  Counterpart: "Agreement.Counterpart",
  MonthlyCost: "Agreement.MonthlyCost",
  TotalCost: "Agreement.TotalCost",
  AddAgreement: "Agreement.AddAgreement",
  SubmitSuccessMessage: "Agreement.SubmitSuccessMessage",
  OrganizationNumber: "Agreement.OrganizationNumber",
  NoticePeriod: "Agreement.NoticePeriod",
  EndsLastHelpText: "Agreement.EndsLastHelpText",
  AgreementDescription: "Agreement.AgreementDescription",
  AttachmentHelpText: "Agreement.AttachmentHelpText",
  }
export default Agreement;